module.exports = __webpack_public_path__ + "img/detail_icon_phone82.e63c8065.png";